import { render, staticRenderFns } from "./ImportUsers.vue?vue&type=template&id=0b267359&scoped=true&"
import script from "./ImportUsers.vue?vue&type=script&lang=js&"
export * from "./ImportUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b267359",
  null
  
)

export default component.exports